import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { ApplicationState } from '../../store';
import { Dispatch } from 'redux';
import 'hammerjs';
// Components
import { GetString } from '../StringResourceManager';
import { AssetStateCountResponse } from '../../Interfaces/Assets/AssetStateCountResponse';
import { getAssetStateNameCount } from '../../store/Devices/AssetStatesActions';
import WidgetTotalCountTile from '../WidgetTotalCountTile';
import { ChartSeriesInterface } from '../../Interfaces/Devices/ChartSeriesInterface';
import { ApiEnums } from '../../Interfaces/ApiEnums';
import { NodeTypeCounts } from '../../Interfaces/Assets/NodeTypeCounts';
import { ChartColors } from './ChartColors';
import {
  saveAssetStatusesFilters,
  saveAssetStatusesGridState,
} from '../../store/UserSettings/UserSettingsActions';
import { CompositeFilterDescriptor, State } from '@progress/kendo-data-query';
import { ASSET } from '../../utils/constants';

// Styles
const useStylesDevicesOverview = makeStyles((theme: Theme) =>
  createStyles({
    totalCountContainer: {
      display: 'flex',
      flexDirection: 'row',
      height: 140,
    },
  })
);

export default function DeviceWidgetTotalCountTile() {
  const classes = useStylesDevicesOverview();
  const [refresh, setRefresh] = useState<boolean>(true);

  const assetStatusCounts: Map<string, AssetStateCountResponse[]> = useSelector(
    (state: ApplicationState) => state.assetStatusesReducer.assetStatusCounts
  );

  const nodeTypeCounts: NodeTypeCounts = useSelector(
    (state: ApplicationState) => state.assetsReducer.nodeTypeCounts
  );

  const [errorsCount, setErrorsCount] = React.useState<number>(0);

  const [warningsCount, setWarningsCount] = React.useState<number>(0);

  const [totalLanesDown, setTotalLanesDown] = React.useState<number>(0);

  const [statusCounts, setStatusCounts] = React.useState<
    Map<string, AssetStateCountResponse[]>
  >(new Map());

  const [nodeDownCounts, setNodeDownCounts] = React.useState<
    Map<string, AssetStateCountResponse[]>
  >(new Map());

  const dispatch: Dispatch<any> = useDispatch();

  useEffect((): ReturnType<React.EffectCallback> => {
    if (refresh) {
      setRefresh(false);
      getAssetStateNameCount(dispatch, 'Status');
      getAssetStateNameCount(dispatch, 'NodeAvailabilityStatus');
    }
    return (): void => {};
  }, [refresh]);

  useEffect((): ReturnType<React.EffectCallback> => {
    validateAssetStatusCounts(assetStatusCounts);
  }, [assetStatusCounts]);

  useEffect((): ReturnType<React.EffectCallback> => {
    processChartData();
  }, [statusCounts]);

  useEffect((): ReturnType<React.EffectCallback> => {
    let totalLanesDown: number = 0;

    Object.entries(nodeDownCounts).map(([key, value], index) => {
      var assetStateCountResponse: AssetStateCountResponse[] = value;
      for (let i = 0; i < assetStateCountResponse.length; ++i) {
        if (
          Number(assetStateCountResponse[i].Value) ==
          ApiEnums.NodeAvailabilityStatus.NotOperational
        )
          totalLanesDown += assetStateCountResponse[i].Total;
      }
    });

    setTotalLanesDown(totalLanesDown);
  }, [nodeDownCounts]);

  const validateAssetStatusCounts = (
    count: Map<string, AssetStateCountResponse[]>
  ) => {
    if (count.size == 0) return;

    Object.entries(count).map(([key, value], index) => {
      var assetStateCountResponse: AssetStateCountResponse[] = value;
      if (
        key == 'U-Scan' &&
        assetStateCountResponse[0].Name == 'NodeAvailabilityStatus'
      )
        setNodeDownCounts(count);
      else setStatusCounts(count);
      return;
    });
  };

  const processChartData = () => {
    let list: string[] = [];
    let series: ChartSeriesInterface[] = [];

    list = getDeviceWithIssueList();

    getIssuesCount(list);
  };

  const getDeviceWithIssueList = () => {
    let deviceWithIssueList: string[] = [];

    Object.entries(statusCounts).map(([key, value], index) => {
      var assetStateCountResponse: AssetStateCountResponse[] = value;
      var issueFound: boolean = false;
      for (let i = 0; i < assetStateCountResponse.length; ++i) {
        var seriesIndex = Number(assetStateCountResponse[i].Value);

        if (seriesIndex == 2 || seriesIndex == 3) {
          issueFound = true;
          break;
        }
      }

      if (issueFound) deviceWithIssueList.push(key);
    });

    return deviceWithIssueList;
  };

  const getIssuesCount = (deviceWithIssueList: string[]) => {
    let errorsCount: number = 0;
    let warningsCount: number = 0;

    Object.entries(statusCounts).map(([key, value]) => {
      if (deviceWithIssueList.includes(key)) {
        var assetStateCountResponse: AssetStateCountResponse[] = value;

        for (let i = 0; i < assetStateCountResponse.length; ++i) {
          var valueData = Number(assetStateCountResponse[i].Value);

          if (valueData == 0 || valueData == 1) {
            continue;
          }

          if (valueData == 2) {
            warningsCount =
              warningsCount + Number(assetStateCountResponse[i].Total);
          } else if (valueData == 3) {
            errorsCount =
              errorsCount + Number(assetStateCountResponse[i].Total);
          }
        }
      }
    });

    setErrorsCount(errorsCount);
    setWarningsCount(warningsCount);
  };

  const getIssueCountPercentage: any = () => {
    if (totalLanesDown == 0) return 0;
    let totalLanesCounts: number =
      nodeTypeCounts.Robots + nodeTypeCounts.MasterRobots;

    return totalLanesCounts == 0
      ? 0
      : (totalLanesDown / totalLanesCounts) * 100;
  };

  const getLaneDownTileColor = (count: number) => {
    return count <= 0 ? ChartColors.Green : ChartColors.Red;
  };

  const getDeviceErrorsTileColor = (count: number) => {
    if (count <= 0) return ChartColors.Green;
    else if (count <= 50) return ChartColors.Yellow;
    else return ChartColors.Red;
  };

  const getDeviceWarningsTileColor = (count: number) => {
    if (count <= 0) return ChartColors.Green;
    else if (count <= 50) return ChartColors.Yellow;
    else return ChartColors.Red;
  };

  const resetDevicesFilter = () => {
    let filter: CompositeFilterDescriptor = {
      logic: 'and',
      filters: [],
    };
    saveAssetStatusesFilters(dispatch, filter);
  };

  const resetDevicesGridState = () => {
    let gridState: State = {
      skip: 0,
      take: 100,
      filter: {
        logic: 'and',
        filters: [],
      },
    };
    saveAssetStatusesGridState(dispatch, gridState);
  };

  const widgetWarningsCountTileClick = () => {
    resetDevicesFilter();

    let gridState: State = {
      skip: 0,
      take: 100,
      filter: {
        logic: 'and',
        filters: [
          {
            field: ASSET.FIELD_STATUS_LABEL,
            operator: 'eq',
            value: 2,
          },
        ],
      },
    };
    saveAssetStatusesGridState(dispatch, gridState);
  };

  const widgetErrorsCountTileClick = () => {
    resetDevicesFilter();

    let gridState: State = {
      skip: 0,
      take: 100,
      filter: {
        logic: 'and',
        filters: [
          {
            field: ASSET.FIELD_STATUS_LABEL,
            operator: 'eq',
            value: 3,
          },
        ],
      },
    };
    saveAssetStatusesGridState(dispatch, gridState);
  };

  const widgetLanesDownCountTileClick = () => {
    resetDevicesFilter();

    resetDevicesGridState();
  };

  return (
    <div className={classes.totalCountContainer}>
      <WidgetTotalCountTile
        title={GetString('LANES_DOWN')}
        count={totalLanesDown}
        bgColor={getLaneDownTileColor(totalLanesDown)}
        textColor="#fff"
        info={
          '(' +
          getIssueCountPercentage().toFixed(2) +
          GetString('LANES_DOWN_PERCENTAGE') +
          ')'
        }
        goToScreen="devices"
        onClick={widgetLanesDownCountTileClick}
        testId="overview_devices_lanesDownCount"
      />
      <WidgetTotalCountTile
        title={GetString('DEVICE_ERRORS')}
        count={errorsCount}
        bgColor={getDeviceErrorsTileColor(errorsCount)}
        textColor="#fff"
        goToScreen="devices"
        onClick={widgetErrorsCountTileClick}
        testId="overview_devices_deviceErrorsCount"
      />
      <WidgetTotalCountTile
        title={GetString('DEVICE_WARNINGS')}
        count={warningsCount}
        bgColor={getDeviceWarningsTileColor(warningsCount)}
        textColor="#fff"
        goToScreen="devices"
        onClick={widgetWarningsCountTileClick}
        testId="overview_devices_deviceWarningsCount"
      />
    </div>
  );
}
